export const viewReceiverList = '/receivers';
export const viewReceiver = '/receivers';
export const addReceiver = '/receivers';
export const editReceiver = '/receivers';
export const deleteReceiver = '/receivers';